module.exports = __webpack_public_path__ + "img/moscato-xxl.e8965ca3.png";